export default {"src":"/_next/static/media/spain-nab_logo.3cefaff5.svg","height":131,"width":198,"blurWidth":0,"blurHeight":0};